<ion-header class="ion-no-border">
  <ion-toolbar class="ion-no-border">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content no-bounce color="light">
  <ion-grid fixed>
    <ion-row>
      <ion-col size="12" *ngIf="step === 1" class="step-container step-fade-enter">
        <div style="display: block; max-width: 500px; margin: 0 auto;">
          <img id="img-logo-registro" src="./assets/img/logo.png">
          <ion-text class="ion-text-center">
            <p>Plataforma de Educación Médica Continua</p>
          </ion-text>
          <ion-text color="secondary" class="ion-text-center">
            <h1><strong>Registro</strong></h1>
          </ion-text>
          <form [formGroup]="dataForm" (ngSubmit)="saveLocal()" class="ion-text-center form-content">
            <ion-grid [fixed]="true">
              <ion-row>
                <!-- Nombre -->
                <ion-col size="12" class="form-item">
                  <ion-item lines="none" class="item-round" color="light">
                    <ion-icon color="primary" slot="start" name="person-outline"></ion-icon>
                    <ion-input type="text" formControlName="name" placeholder="Nombre"></ion-input>
                  </ion-item>
                  <ion-text color="danger"
                    *ngIf="dataForm.get('name').touched && dataForm.get('name').getError('required')">
                    <span class="ion-padding">El nombre es obligatorio</span>
                  </ion-text>
                </ion-col>
                <!-- Apellido paterno -->
                <ion-col size="12" class="form-item">
                  <ion-item lines="none" class="item-round" color="light">
                    <ion-icon color="primary" slot="start" name="person-outline"></ion-icon>
                    <ion-input type="text" formControlName="lastName1" placeholder="Apellido paterno"></ion-input>
                  </ion-item>
                  <ion-text color="danger"
                    *ngIf="dataForm.get('lastName1').touched && dataForm.get('lastName1').getError('required')">
                    <span class="ion-padding">El apellido paterno es obligatorio</span>
                  </ion-text>
                </ion-col>
                <!-- Apellido materno -->
                <ion-col size="12" class="form-item">
                  <ion-item lines="none" class="item-round" color="light">
                    <ion-icon color="primary" slot="start" name="person-outline"></ion-icon>
                    <ion-input type="text" formControlName="lastName2" placeholder="Apellido materno"></ion-input>
                  </ion-item>
                  <ion-text color="danger"
                    *ngIf="dataForm.get('lastName2').touched && dataForm.get('lastName2').getError('required')">
                    <span class="ion-padding">El apellido materno es obligatorio</span>
                  </ion-text>
                </ion-col>
                <!-- Código postal -->
                <ion-col size="12">
                  <ion-progress-bar *ngIf="isLoading === true" type="indeterminate"></ion-progress-bar>
                  <ion-item lines="none" class="item-round" color="light">
                    <ion-icon color="primary" slot="start" name="navigate-outline"></ion-icon>
                    <ion-input placeholder="Código postal" type="tel" formControlName="postal_code" [debounce]="1500"
                      (ionInput)="postalCode($event)">
                    </ion-input>
                  </ion-item>
                  <ion-text class="item-with-error" color="danger"
                    *ngIf="dataForm.get('postal_code').touched && dataForm.get('postal_code').getError('required')">
                    <span class="ion-padding">El código postal es obligatorio</span>
                  </ion-text>
                  <ion-text class="item-with-error" color="danger"
                    *ngIf="dataForm.get('postal_code').touched && dataForm.get('postal_code').getError('pattern')">
                    <span class="ion-padding">Ingrese un código postal válido</span>
                  </ion-text>
                  <ion-text color="medium"
                    *ngIf="dataForm.get('colony')?.value && dataForm.get('delegation')?.value && dataForm.get('state')?.value">
                    <small *ngIf="dataForm?.get('state')?.value === 'Ciudad de México'; else provincia">
                      {{
                      (dataForm?.get('colony')?.value !== null ? dataForm.get('colony').value + ', ' : '') +
                      (dataForm?.get('delegation')?.value !== null ? dataForm.get('delegation').value + ', ' : '') +
                      (dataForm?.get('state')?.value !== null ? dataForm.get('state').value : '')
                      }}
                    </small>
                    <ng-template #provincia>
                      <small>
                        {{
                        (dataForm?.get('colony')?.value !== null ? dataForm.get('colony').value + ', ' : '') +
                        (dataForm?.get('city')?.value !== null ? dataForm.get('city').value + ', ' : '') +
                        (dataForm?.get('state')?.value !== null ? dataForm.get('state').value : '')
                        }}
                      </small>
                    </ng-template>
                  </ion-text>
                </ion-col>
                <!-- Numero telefonico -->
                <ion-col size="12">
                  <ion-item lines="none" class="item-round" color="light">
                    <ion-icon color="primary" slot="start" name="phone-portrait-outline"></ion-icon>
                    <ion-input formControlName="mobile" placeholder="Telefono celular 10 digitos" type="tel"
                      inputmode="tel"></ion-input>
                  </ion-item>
                  <ion-text class="item-with-error" color="danger"
                    *ngIf="dataForm.get('mobile').touched && dataForm.get('mobile').hasError('required')">
                    <span class="ion-padding">El número de teléfono es obligatorio</span>
                  </ion-text>
                  <ion-text class="item-with-error" color="danger"
                    *ngIf="dataForm.get('mobile').touched && dataForm.get('mobile').hasError('invalidPhone')">
                    <span class="ion-padding">El número de teléfono debe tener exactamente 10 dígitos</span>
                  </ion-text>
                </ion-col>
                <!-- Numero email -->
                <ion-col size="12">
                  <ion-item lines="none" class="item-round" color="light">
                    <ion-icon color="primary" slot="start" name="mail-outline"></ion-icon>
                    <ion-input type="text" formControlName="email" placeholder="Email" [debounce]="1000"
                      (ionInput)="emailChange($event)"></ion-input>
                  </ion-item>
                  <ion-text class="item-with-error" color="danger"
                    *ngIf="dataForm.get('email').touched && dataForm.get('email').getError('required')">
                    <span class="ion-padding">El correo electrónico es obligatorio</span>
                  </ion-text>
                  <ion-text class="item-with-error" color="danger" *ngIf="
                        dataForm.get('email').touched &&
                        dataForm.get('email').getError('pattern') &&
                        !dataForm.get('email').getError('required')
                      ">
                    <span class="ion-padding">El correo electrónico es incorrecto</span>
                  </ion-text>
                  <ng-container *ngIf="dataForm.get('email').pending">
                    <ion-text color="medium" class="item-with-error">
                      <ion-spinner name="dots" style="vertical-align: middle; margin-right: 8px;"></ion-spinner>
                      <span>Verificando correo electrónico</span>
                    </ion-text>
                  </ng-container>
                  <ion-text class="item-with-error" color="danger"
                    *ngIf="!dataForm.get('email').pending && dataForm.get('email').hasError('emailAlreadyExists')">
                    <p>El correo electrónico ya está registrado en una cuenta.</p>
                    <ion-text color="secondary">
                      <p> ¿Desea ingresar a su cuenta?</p>
                    </ion-text>
                    <ion-button (click)="modalLogin()" color="secondary" fill="outline">
                      <ion-icon slot="start" name="log-in-outline"></ion-icon>
                      Ingresar
                    </ion-button>
                  </ion-text>
                  <ion-text class="item-with-success" color="success" *ngIf="
                      !dataForm.get('email').pending &&
                      dataForm.get('email').valid &&
                      !dataForm.get('email').hasError('emailAlreadyExists')
                    ">
                    <ion-icon name="checkmark-circle-outline"
                      style="vertical-align: middle; margin-right: 8px;"></ion-icon>
                    <span>El correo electrónico es correcto</span>
                  </ion-text>
                </ion-col>
                <!-- password -->
                <ion-col size="12">
                  <ion-item lines="none" class="item-round" color="light">
                    <ion-icon color="primary" slot="start" name="key-outline"></ion-icon>
                    <ion-input [type]="showPassword === true ? 'text': 'password'" clearOnEdit="false"
                      autocomplete="current-password" formControlName="password"
                      placeholder="Crear contraseña"></ion-input>
                    <div class="float-eye">
                      <ion-button color="secondary" (click)="showPassword = !showPassword" fill="clear">
                        <ion-icon slot="end"
                          [name]="showPassword === true ? 'eye-off-outline': 'eye-outline'"></ion-icon>
                      </ion-button>
                    </div>
                  </ion-item>
                  <ion-text class="item-with-error" color="danger"
                    *ngIf="dataForm.get('password').touched && dataForm.get('password').getError('required')">
                    <span class="ion-padding">La contraseña es obligatoria</span>
                  </ion-text>
                  <ion-text class="item-with-password" color="danger"
                    *ngIf="dataForm.get('password').touched && dataForm.get('password').getError('minlength')">
                    <span class="ion-padding">La contraseña debe tener al menos 6 caracteres</span>
                  </ion-text>
                </ion-col>
              </ion-row>
              <!-- terminos y condiciones -->
              <ion-row>
                <ion-col size="12">
                  <div class="custom-flex">
                    <ion-checkbox formControlName="termsAndConditions" style="top: 5px;"></ion-checkbox>
                  </div>
                  <div class="custom-flex">
                    <p>Acepto los <a (click)="termOfUseComponent()">Términos y Condiciones</a></p>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
            <div class="form-buttons">
              <ion-button expand="block" type="submit" color="tertiary" [disabled]="       
            !dataForm.valid === true || !dataForm.value.termsAndConditions === true || isLoading === true">
                Continuar
              </ion-button>
            </div>
            <ion-text color="medium">
              <p class="ion-text-right">1-2</p>
            </ion-text>
          </form>
        </div>
      </ion-col>
      <input id="file" class="hide" #file name="file"
        accept="image/*,.doc, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
        type="file" name="file" (change)="selectFile($event.target)" />
      <ion-col size="12" *ngIf="step === 2" class="step-container step-fade-enter">
        <div style="display: block; max-width: 500px; margin: 0 auto;">
          <img id="img-logo-registro" src="./assets/img/logo.png">
          <ion-text class="ion-text-center">
            <p>Plataforma de Educación Médica Continua</p>
          </ion-text>
          <ion-text color="secondary" class="ion-text-center">
            <h1><strong>Complemente su información</strong></h1>
          </ion-text>
          <form [formGroup]="dataFormEsp" (ngSubmit)="beforeRegister()" class="ion-text-center form-content">
            <ion-grid [fixed]="true">
              <ion-row>
                <ion-col size="12" class="form-item">
                  <ion-item lines="none" class="item-round" color="light">
                    <ion-icon color="primary" slot="start" name="school-outline"></ion-icon>
                    <ion-select (ionChange)="onMetaTypeChange($event)" label="Tipo de registro"
                      formControlName="metaType" multiple="false" placeholder="Seleccione el tipo de registro">
                      <ion-select-option *ngFor="let item of metaType" [value]="item?.value">{{ item?.label
                        }}</ion-select-option>
                    </ion-select>
                  </ion-item>
                </ion-col>
                <ion-col size="12">
                  <div [ngSwitch]="dataFormEsp?.get('metaType')?.value">
                    <div *ngSwitchCase="'medico'">
                      <!-- Médico -->
                      <ion-grid class="ion-no-padding">
                        <ion-row>
                          <!-- Cédula profesional -->
                          <ion-col size="12" class="form-item">
                            <ion-item lines="none" class="item-round" color="light">
                              <ion-icon color="primary" slot="start" name="id-card-outline" size="small"></ion-icon>
                              <ion-input type="text" formControlName="cedula" placeholder="Ingrese cédula profesional"
                                size="small"></ion-input>
                            </ion-item>
                            <ion-text color="danger"
                              *ngIf="dataFormEsp.get('cedula').touched && dataFormEsp.get('cedula').getError('required')">
                              <span class="ion-padding">Cédula profesional es obligatoria</span>
                            </ion-text>
                            <ion-text color="danger"
                              *ngIf="dataFormEsp.get('cedula').touched && dataFormEsp.get('cedula').getError('pattern')">
                              <span class="ion-padding">Ingrese una cédula profesional válida</span>
                            </ion-text>
                          </ion-col>
                        </ion-row>
                      </ion-grid>
                    </div>
                    <div *ngSwitchCase="'medico-en-formacion'">
                      <!-- Médico en formación -->
                      <ion-grid class="ion-no-padding">
                        <ion-row>
                          <!-- Documento validador -->
                          <ion-col size="12" class="form-item ion-margin-bottom">
                            <ion-item lines="none" class="item-round" color="light">
                              <ion-icon color="primary" slot="start" name="document-outline" size="small"></ion-icon>
                              <label color="medium">Documento de acreditación
                                <ion-button style="margin-top: -10px;" fill="clear" shape="round" color="dark"
                                  (click)="showTooltip($event,'Cargue un documento que acredite sus estudios ej. credencial, matrícula (pdf o imagen)')">
                                  <ion-icon slot="icon-only" name="help-circle-outline"></ion-icon>
                                </ion-button>
                              </label>
                              <ion-button expand="block" fill="clear" shape="round" [disabled]="isLoading === true"
                                (click)="presentActionSheet()">
                                Seleccionar
                              </ion-button>
                            </ion-item>
                            <ion-text color="primary" *ngIf="dataFormEsp?.get('verificationFile')?.value">
                              <ion-icon class="icon-top" color="success" name="checkmark-circle-outline"></ion-icon>
                              <small>Documento cargado</small>
                            </ion-text>
                            <ion-text color="danger"
                              *ngIf="dataFormEsp.get('verificationFile').touched && dataFormEsp.get('verificationFile').getError('required')">
                              <span class="ion-padding">El documento es obligatorio</span>
                            </ion-text>
                          </ion-col>
                          <!-- tiempo que le falta para terminar sus estudios -->
                          <ion-col size="12" class="form-item">
                            <ion-item lines="none" class="item-round" color="light">
                              <ion-icon color="primary" slot="start" name="calendar-outline"></ion-icon>
                              <ion-select [label]="selectLabel" formControlName="estimatedGraduationTime"
                                placeholder="Seleccione el plazo que resta para concluir sus estudios"
                                (click)="onSelectOpen()" (ionDismiss)="onSelectClose()">
                                <ion-select-option *ngFor="let option of estimatedGraduationTimeOptions"
                                  [value]="option?.value">{{ option?.label }}</ion-select-option>
                              </ion-select>
                            </ion-item>
                            <ion-text color="danger"
                              *ngIf="dataFormEsp.get('estimatedGraduationTime').touched && dataFormEsp.get('estimatedGraduationTime').getError('required')">
                              <span class="ion-padding">Seleccione el plazo que resta para concluir sus estudios</span>
                            </ion-text>
                          </ion-col>
                        </ion-row>
                      </ion-grid>
                    </div>
                    <div *ngSwitchCase="'profesional-de-la-salud'">
                      <!-- Profesional de la salud -->
                      <ion-grid class="ion-no-padding">
                        <ion-row>
                          <!-- Nivel educativo solo para profesional-de-la-salud -->
                          <ion-col size="12" class="form-item">
                            <ion-item lines="none" class="item-round ion-margin-bottom" color="light"
                              style="--inner-padding-end: 0; --padding-start: 0;">
                              <ion-icon color="primary" slot="start" name="layers-outline"
                                style="margin-left: 16px;"></ion-icon>
                              <div style="flex: 1; padding: 16px 16px 16px 0;">
                                <div style="margin-bottom: 12px;">
                                  <ion-label style="font-weight: bold; font-size: 16px;">Nivel educativo</ion-label>
                                </div>
                                <ion-radio-group formControlName="educationalLevel"
                                  (ionChange)="onEducationalLevelChange($event)">
                                  <ion-item lines="none"
                                    style="--background: transparent; --padding-start: 0; --inner-padding-end: 0; --min-height: 40px; margin-bottom: 8px;"
                                    *ngFor="let option of educationalLevelOptions">
                                    <ion-radio labelPlacement="fixed" [value]="option.value">{{ option.label
                                      }}</ion-radio>
                                  </ion-item>
                                </ion-radio-group>
                              </div>
                            </ion-item>
                            <ion-text color="danger"
                              *ngIf="dataFormEsp.get('educationalLevel').touched && dataFormEsp.get('educationalLevel').getError('required')"
                              class="item-with-error">
                              <span class="ion-padding">El nivel educativo es requerido</span>
                            </ion-text>
                          </ion-col>
                          <!-- Documento validador -->
                          <ion-col size="12" class="form-item ion-margin-bottom"
                            *ngIf="dataFormEsp?.value?.educationalLevel == 'estudiante' || dataFormEsp?.value?.educationalLevel == 'tecnico'">
                            <ion-item lines="none" class="item-round" color="light">
                              <ion-icon color="primary" slot="start" name="document-outline" size="small"></ion-icon>
                              <label color="medium">Documento de acreditación
                                <ion-button style="margin-top: -10px;" fill="clear" shape="round" color="dark"
                                  (click)="showTooltip($event,'Cargue un documento que acredite sus estudios ej. credencial, matrícula (pdf o imagen)')">
                                  <ion-icon slot="icon-only" name="help-circle-outline"></ion-icon>
                                </ion-button>
                              </label>
                              <ion-button expand="block" fill="clear" shape="round" [disabled]="isLoading === true"
                                (click)="presentActionSheet()">
                                Seleccionar
                              </ion-button>
                            </ion-item>
                            <ion-text color="primary" *ngIf="dataFormEsp?.get('verificationFile')?.value">
                              <ion-icon class="icon-top" color="success" name="checkmark-circle-outline"></ion-icon>
                              <small>Documento cargado</small>
                            </ion-text>
                            <ion-text color="danger"
                              *ngIf="dataFormEsp.get('verificationFile').touched && dataFormEsp.get('verificationFile').getError('required')">
                              <span class="ion-padding">El documento es requerido</span>
                            </ion-text>
                          </ion-col>
                          <!-- tiempo que le falta para terminar sus estudios -->
                          <ion-col size="12" class="form-item"
                            *ngIf="dataFormEsp?.value?.educationalLevel == 'estudiante'">
                            <ion-item lines="none" class="item-round" color="light">
                              <ion-icon color="primary" slot="start" name="calendar-outline"></ion-icon>
                              <ion-select [label]="selectLabel" formControlName="estimatedGraduationTime"
                                placeholder="Seleccione el plazo que resta para concluir sus estudios"
                                (click)="onSelectOpen()" (ionDismiss)="onSelectClose()">
                                <ion-select-option *ngFor="let option of estimatedGraduationTimeOptions"
                                  [value]="option?.value">{{ option?.label }}</ion-select-option>
                              </ion-select>
                            </ion-item>
                            <ion-text color="danger"
                              *ngIf="dataFormEsp.get('estimatedGraduationTime').touched && dataFormEsp.get('estimatedGraduationTime').getError('required')">
                              <span class="ion-padding">Seleccione el plazo que resta para concluir sus estudios</span>
                            </ion-text>
                          </ion-col>
                          <!-- Cédula profesional -->
                          <ion-col size="12" class="form-item"
                            *ngIf="dataFormEsp?.value?.educationalLevel == 'universitario'">
                            <ion-item lines="none" class="item-round" color="light">
                              <ion-icon color="primary" slot="start" name="id-card-outline" size="small"></ion-icon>
                              <ion-input type="text" formControlName="cedula" placeholder="Ingrese cédula profesional"
                                size="small"></ion-input>
                            </ion-item>
                            <ion-text color="danger"
                              *ngIf="dataFormEsp.get('cedula').touched && dataFormEsp.get('cedula').getError('required')">
                              <span class="ion-padding">Cédula profesional es obligatoria</span>
                            </ion-text>
                            <ion-text color="danger"
                              *ngIf="dataFormEsp.get('cedula').touched && dataFormEsp.get('cedula').getError('pattern')">
                              <span class="ion-padding">Ingrese una cédula profesional válida</span>
                            </ion-text>
                          </ion-col>
                        </ion-row>
                      </ion-grid>
                    </div>
                  </div>
                </ion-col>
                <ion-col size="12" class="form-item">
                  <ion-item lines="none" class="item-round" color="light">
                    <ion-icon color="primary" slot="start" name="list-outline"></ion-icon>
                    <ion-select label="Áreas de interés" formControlName="personalInterests"
                      placeholder="Seleccione sus áreas de interés" [multiple]="true">
                      <ion-select-option *ngFor="let interest of personalInterests" [value]="interest.id">{{
                        interest.name }}</ion-select-option>
                    </ion-select>
                  </ion-item>
                  <ion-text color="danger"
                    *ngIf="dataFormEsp.get('personalInterests').touched && dataFormEsp.get('personalInterests').getError('required')">
                    <span class="ion-padding">Seleccione al menos un área de interés</span>
                  </ion-text>
                </ion-col>
              </ion-row>
            </ion-grid>
            <div class="form-buttons">
              <ion-grid fixed>
                <ion-row>
                  <ion-col size="6">
                    <ion-button expand="block" fill="outline" color="dark" (click)="transitionToStep(1)"
                      [disabled]="isLoading === true">
                      Anterior
                    </ion-button>
                  </ion-col>
                  <ion-col size="6">
                    <ion-button expand="block" type="submit" color="tertiary"
                      [disabled]="!dataFormEsp.valid === true || isLoading === true">
                      Enviar
                    </ion-button>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
            <ion-text color="medium">
              <p class="ion-text-right">2-2</p>
            </ion-text>
          </form>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>